import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { API, get } from "../../config";
import { toast } from "react-toastify";
import Spin from "../common/Spin";
import { formatMobile, formatName, formatPhone } from "../common/Misc";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";

const RegisteredUserDetail = ({ userId, toggleShowModal, showView }) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(
          `${API.GET_REGISTERED_USER_FOR_ADMIN}/${userId}`
        );
        setDetail(data?.data);
        setLoading(false);
      } catch (error) {
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
          setLoading(false);
        }
      }
    }
    fetchData();
  }, [userId]);

  const columns = [
    {
      dataField: "name",
      text: "Name",
      style: {
        width: "50%",
      },
    },
    {
      dataField: "email",
      text: "Email",
      style: {
        width: "50%",
      },
    },
  ];

  const relationUsersGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: detail?.relations[i]?.id,
        id: detail?.relations[i]?.id ? detail?.relations[i]?.id : "",
        name: formatName(
          detail?.relations[i]?.first_name,
          detail?.relations[i]?.last_name
        ) + (detail?.relations[i]?.business_name ? ` (${detail?.relations[i]?.business_name})` : ""),
        email: detail?.relations[i]?.email,
      });
    }
    return items;
  };

  const relationUsers = relationUsersGenerator(detail?.relations?.length);

  return (
    <Modal
      size="lg"
      show={showView}
      onHide={toggleShowModal}
      dialogClassName="modal-50w larg-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Registered User Details
      </Modal.Header>
      <Modal.Body>
        <div style={{ maxheight: "90vh", overflow: "auto" }}>
          {loading ? (
            <Spin />
          ) : (
            <>
              <div className="modal-content-details">
                <p>
                  <strong>Name:</strong>{" "}
                  {formatName(detail?.first_name, detail?.last_name)}
                </p>
                <p>
                  <strong>Email:</strong> {detail?.email}
                </p>
                <p>
                  <strong>Phone:</strong>
                  {detail?.phone ? formatPhone(detail?.phone) : ""}
                </p>
                <p>
                  <strong>Mobile:</strong>
                  {detail?.mobile ? formatMobile(detail?.mobile) : ""}
                </p>
                <p>
                  <strong>Role:</strong>
                  {detail?.role?.name ? detail?.role?.name : ""}
                </p>
                <p>
                  <strong>Registered Date:</strong>
                  {detail?.created_at
                    ? moment(detail?.created_at, "DD-MM-YYYY HH:mm:SS").format(
                        "DD-MM-YYYY"
                      )
                    : ""}
                </p>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <p>
                    <strong>
                      {detail?.role?.name === "Builder"
                        ? "Accounting Firm"
                        : "Builder"}
                      :-
                    </strong>
                  </p>
                  <BootstrapTable
                    columns={columns}
                    keyField="email"
                    noDataIndication="No Data Found"
                    remote
                    data={relationUsers}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RegisteredUserDetail;
